import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { ConsentDataObject } from 'models/service';

type RequestData = {
  consent: {
    // eslint-disable-next-line @typescript-eslint/naming-convention -- Keys are defined by Backend API endpoint
    consent_ids: string[];
  };
};

export const acceptConsents = async (data: RequestData) =>
  apiClient.post<ConsentDataObject[], ApiClientResponse<ConsentDataObject[]>>(routes.consents.accept, data);
